<template>
	<div class="recruitBox">
		<div class="banner">
			<p class="txt">JOIN US<br />招贤纳士</p>
		</div>
		<div class="joinBox">
			<p class="title">携手英才，共创未来</p>
			<p class="tip">请将简历发送到招聘邮箱，邮件主题标明应聘岗位姓名等，<br>符合应聘资格者，我们会及时与您取得联系。</p>
			<div class="email">
				招聘邮箱：
				<span>HR@zminfra.cn</span>
			</div>
			<a-collapse v-model="activeKey" :expand-icon-position="'right'">
				<a-collapse-panel v-for="(item,idx) in list">
					<template slot="header">
						<div class="flexBox">
							<div class="name">{{item.title}}</div>
							<div class="val">招聘人数：{{item.headcount}}人</div>
						</div>
					</template>
					<div class="infoBox">
						<div class="txt">岗位职责：</div>
						<div class="des" v-html="item.description" style="white-space: pre-wrap;"></div>
						<div class="txt">任职要求：</div>
						<div class="des" v-html="item.requirement" style="white-space: pre-wrap;"></div>
					</div>
				</a-collapse-panel>
			</a-collapse>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Recruit',
		components: {

		},
		data() {
			return {
				list: [],
				activeKey:[],
				selId:null,
			}
		},
		mounted() {
			var id = this.$route.query.id;
			if(id != undefined){
				this.selId = id
			};
			
			this.getData();
		},
		methods: {
			getData() {
				this.$req("get", "/api/cms/jobPosition/all").then((res) => {
					for(let i = 0;i<res.data.length;i++){
						if(this.selId != null && res.data[i].id == this.selId){
							this.activeKey = [i]
						}
					};
					this.list = res.data;
				});
			},
		}
	}
</script>

<style scoped>
	@import url("../../../assets/css/portal/recruit.css");
</style>